<template>
  <div>
    <div class="sayfahead tek">
      <h1>Yazdırılacak Dökümler</h1>
      <el-button-group class="float-right YeniBtn">
        <el-button type="info" size="small" @click="SayfaYukle()">
          Yenile
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <div class="SpotlightKutu" style="z-index: 1">
        <div class="input">
          <el-input
            :disabled="lo"
            placeholder="Bina Adı yazarak aratınız"
            v-model="search">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <el-table
        v-if="DokumListe"
        :data="DokumListe.filter(data => !search || data.BinaAdi.toLowerCase().includes(search.toLowerCase()))"
        class="golgetable"
        @current-change="TableSecim"
        :height="Height">
        <el-table-column
          label="F"
          prop="eFaturaLink"
          width="40">
          <template slot-scope="scope">
            <i v-if="scope.row.eFaturaLink" class="el-icon-success text-success"></i>
            <i v-if="!scope.row.eFaturaLink" class="el-icon-error text-danger"></i>
          </template>
        </el-table-column>
        <el-table-column
          label="Bina Adı"
          prop="BinaAdi">
        </el-table-column>
        <el-table-column
          label="Dönem Adı"
          prop="aciklama">
        </el-table-column>
        <el-table-column
          label="Onaylayan"
          prop="Onaylayan"
          width="200">
        </el-table-column>
      </el-table>

      <Yukleniyor :data="lo"></Yukleniyor>


    </div>
  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";


export default {
  components: {Yukleniyor},
  data() {
    return {
      DokumListe: null,
      lo: false,
      search: '',
      Height: window.innerHeight - 100,
    }
  },
  methods: {
    TableSecim(row) {
      this.$router.push('/dokum/' + row.id)
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/dokum/liste'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.DokumListe = response.Liste;
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    }
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Dokum/Index.vue